import { render, staticRenderFns } from "./ConsignmentPeek.vue?vue&type=template&id=2f1bca3b&"
import script from "./ConsignmentPeek.vue?vue&type=script&lang=js&"
export * from "./ConsignmentPeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports